<template>
  <div class="view w-100">
    <div class="row p-0 acry-text-body text-start m-auto" style="width: 650px; font-size: 15px;">
      <p class="m-0">メールアドレスを変更します。</p>
      <p class="m-0">新しいメールアドレスを入力して下さい。</p>
      <p class="m-0">入力されたメールアドレスに認証用のメールを送信します。</p>
      <p class="m-0">メール内に記載されているURLをクリックするとメールアドレスの変更が完了します。</p>
    </div>

    <div class="row p-0 text-start m-auto pt-4" style="width: 400px;">
      <p class="acry-text-title m-0" style="font-size: 16px;">現在のメールアドレス</p>
      <p class="acry-text-body m-0">{{mailaddress}}</p>
    </div>
    <div class="row p-0 text-start m-auto pt-4" style="width: 400px;">
      <p class="acry-text-title m-0" style="font-size: 16px;">新しいメールアドレス</p>
      <form>
        <div class="row justify-content-center w-100">
          <div class="col-auto w-100">
            <input
              type="email"
              class="acry-input w-100 my-1" :class="{'input-error':error}"
              v-model="email"
              v-on:keydown.enter="updateEmail()"
              placeholder="メールアドレス" />
            <p v-if="error" class="acry-text-body acry-error-text m-0" style="font-size: 13px;">{{error}}</p>
            <p v-else class="acry-text-body m-0" style="font-size: 13px;">お間違いの無いようご注意下さい。</p>
          </div>
        </div>
      </form>
    </div>

    <button type="button" class="acry-btn-primary-normal fw-bold m-4" style="width:250px; height:56px;" @click="updateEmail()">認証メールを送信</button>

  </div>
</template>

<script>
import { Common } from "@/js/common.js";
import { User } from "@/js/User.js";
import firebase from "firebase/app";
import "firebase/auth";


export default {
  name: "CenterViewShippingMail_Ap",
  props: {},
  data() {
    return {
      email: "",
      error: "",
      mailaddress: "",

    };
  },
  created: async function () {
    this.mailaddress = User.userData.email;
  },
  methods: {
    async updateEmail(){
      this.$store.commit("showLoading");
      this.error = "";

      if (Common.isInValidEmail(this.email)) {
        this.error = "正しいメールアドレスを入力してください";
        this.$store.commit("hideLoading");
        return;
      }

      let oldEmail = firebase.auth().currentUser.email;
      let newEmail = this.email;

      if( User.credential ){
        await firebase.auth().signInWithCredential( User.credential );
      }

      let result = true;
      await firebase.auth().currentUser.updateEmail(this.email).catch((error) => {
        result = false;
        //this.$store.commit("showMessage", "エラーが発生しました");
        this.$handleError("050", error, { hideLoading: true, message: "エラーが発生しました。\n左下メニューからログアウトしてから再度ログインし、\nもう一度お試しください。" });
      });

      if( !result ) return;

      // メール認証がまだの場合のみ認証メールの送信
      if (!firebase.auth().currentUser.emailVerified) {
        await firebase.auth().currentUser.sendEmailVerification();
      }

      // サーバーの情報を更新
      await User.registInfo({email:firebase.auth().currentUser.email}).catch((error) => {
        this.$handleError("051", error, { hideLoading: true });
        return;
      });
      this.mailaddress = User.userData.email;

      // メールアドレス変更履歴を保存
      await firebase.firestore().collection("ChangeEmailLog").add(
        {
          "createdate":new Date(),
          "fromAddress":oldEmail,
          "toAddress":newEmail,
        });

      this.$store.commit("showMessage", "認証メールを送信しました");
      this.$store.commit("hideLoading");
    }
  },
};
</script>
<style scoped lang="scss">
.view{
  font-family: 'Noto Sans JP';
  font-size: 15px;
  // text-align: left;
}

.input-error{
  border: 1px solid $status-error-color;
  background: #FFF6F6;
}

</style>
